import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  FormattedMessage, FormattedHTMLMessage, defineMessages, injectIntl,
} from 'react-intl';
import { DropdownList } from 'react-widgets';
import { AssessmentConstants } from '../../../../shared/Constants';
import DownloadReportButton from '../../../../components/button/DownloadReportButton';
import LanguageSelectorNoForm from '../../../../components/input/LanguageSelectorNoForm';
import { intlShape } from '../../../../components/prop-types';

const messages = defineMessages({
  reportSummary: {
    id: 'report.summary',
    defaultMessage: 'Summary Report',
  },
  reportInterview: {
    id: 'report.interview',
    defaultMessage: 'Interview Report',
  },
  reportManagement: {
    id: 'report.management',
    defaultMessage: 'Management Report',
  },
});

class TargetJobReport extends Component {
  constructor(props) {
    super(props);
    const { reportParams } = props;
    this.handleChangeState = this.handleChangeState.bind(this);
    this.ChangeSurveyPrinterFiendly = this.ChangeSurveyPrinterFiendly.bind(this);
    this.state = {
      reportType: AssessmentConstants.REPORT_TYPE.SUMMARY,
      locale: reportParams.locale,
      printerFriendly: reportParams.printerFriendlyReport,
    };
  }

  handleChangeState(name, value) {
    this.setState({ [name]: value });
  }

  ChangeSurveyPrinterFiendly(event) {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.setState({ printerFriendly: value });
  }

  render() {
    const {
      availableTranslations, currentAccount, intl, reportParams: reportParamData,
    } = this.props;

    const { formatMessage } = intl;
    const { assessment, jobProfile } = reportParamData;
    const { locale, printerFriendly, reportType } = this.state;
    const reportTypes = [
      {
        value: AssessmentConstants.REPORT_TYPE.SUMMARY,
        text: formatMessage(messages.reportSummary),
      },
      {
        value: AssessmentConstants.REPORT_TYPE.INTERVIEW,
        text: formatMessage(messages.reportInterview),
      },
      {
        value: AssessmentConstants.REPORT_TYPE.MANAGEMENT,
        text: formatMessage(messages.reportManagement),
      },
    ];

    const reportParams = {
      account: currentAccount,
      locale,
      printerFriendly,
      jobProfile,
      assessment,
    };
    return (
      <div>
        <div className="form-group">
          <p className="sentence-capitalized">
            <FormattedHTMLMessage
              id="tooltip.download_open_window_hint"
              // eslint-disable-next-line max-len
              defaultMessage="Reports are opened in a <strong>new window</strong>. Please <strong>enable pop-up</strong> windows for this website."
            />
          </p>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="report-type" className="field-label">
                <FormattedMessage id="report" defaultMessage="Report" />
              </label>
              <DropdownList
                filter="contains"
                data={reportTypes}
                onChange={value => this.handleChangeState('reportType', value.value)}
                defaultValue={AssessmentConstants.REPORT_TYPE.SUMMARY}
                valueField="value"
                textField="text"
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="report-type" className="field-label">
                <FormattedMessage id="profile.locale" defaultMessage="Preferred language" />
              </label>
              <LanguageSelectorNoForm
                filter="contains"
                data={availableTranslations}
                onChange={value => this.handleChangeState('locale', value.value)}
                defaultValue={locale}
                valueField="tag"
                textField="name"
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <input
                type="checkbox"
                name="printerFriendlyReport"
                onChange={this.ChangeSurveyPrinterFiendly}
                defaultChecked={printerFriendly}
              />
              <FormattedMessage
                id="preferences.prefer-printer-friendly-reports"
                defaultMessage="I prefer printer friendly reports"
              >
                {text => (
                  <span>
                    {' '}
                    {text}
                  </span>
                )}
              </FormattedMessage>
            </div>
          </div>
        </div>
        <div className="row">
          {reportType === 'INTERVIEW' && (
            <DownloadReportButton
              buttonClass=""
              reportParams={reportParams}
              typeButton="generate"
              additionalClass="clearfix text-center"
              type={reportType}
              isDisabled={false}
            />
          )}
          {reportType === 'SUMMARY' && (
            <DownloadReportButton
              buttonClass=""
              reportParams={reportParams}
              typeButton="generate"
              additionalClass="clearfix text-center"
              type={reportType}
              isDisabled={false}
            />
          )}
          {reportType === 'MANAGEMENT' && (
            <DownloadReportButton
              buttonClass=""
              reportParams={reportParams}
              typeButton="generate"
              additionalClass="clearfix text-center"
              type={reportType}
              isDisabled={false}
            />
          )}
        </div>
      </div>
    );
  }
}

TargetJobReport.propTypes = {
  availableTranslations: PropTypes.arrayOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
  reportParams: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default injectIntl(TargetJobReport);
